import "./timeline.css";
import { FormattedMessage, useIntl } from "react-intl";
import { assetsMap, imageInitializer } from "../../model/assets.js";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import gallery from "../../assets/gallery.svg";

let sortedAssets = [];
let groupedAssets = [];
let referenceValue;
let referenceGroup = [];

const getFormattedDate = (months, value) => {
    const d = value[1].date.split("-");
    return `${months[d[1] - 1]} ${d[2]}`;
}

const getManyStyle = (value, index) => {
    return {
        maxHeight: 40 + (value[1].name.length - index) * 1.5 + "%",
        transform: `translate(
            calc(-50% ${index % 2 > 0 ? "-" : "+"} ${ 50 * Math.log(index + 1)}%),
            calc(-50% ${(index + value[1].name.length) % 3 > 0 ? "+" : "-"} ${value[1].date.split("-")[0] * 3 * Math.log(index + 1)}%)
            )`
    }
}

export const TimelineView = () => {
    const [sAssets, setSAssets] = useState([]);
    if(!sAssets.length && sortedAssets.length > 0) {
        setSAssets(sortedAssets);
    }
    const [split, setSplit] = useState([]);
    const [minScale, setScale] = useState(window.matchMedia("(min-width: 700px)").matches ? 0.6 : 0.45);
    const months = useIntl().messages.months;
    useEffect(() => {
        let timeout;
        if(!sortedAssets.length || assetsMap.busy) {
            timeout = imageInitializer(setSAssets, "date");
            sortedAssets = sAssets.sort(
                (a, b) => b[1].date.split("-").reverse().join("") - a[1].date.split("-").reverse().join(""));
            groupedAssets = [];
            referenceValue = sortedAssets[0];
            referenceGroup = [];
            sortedAssets.forEach(current => {
                    if (referenceValue[1].date.split("-").reverse().join("") - current[1].date.split("-").reverse().join("") < 30) {
                        referenceGroup.push(current);
                    } else {
                        groupedAssets.push(referenceGroup);
                        referenceValue = current;
                        referenceGroup = [current];
                    };
                });
                referenceGroup.length && groupedAssets.push(referenceGroup);
        }
        const handleResize = () => setScale(window.matchMedia("(min-width: 700px)").matches ? 0.6 : 0.45);
        window.addEventListener("resize", handleResize);
        document.querySelector("footer").style.display="none";
        return () => {
            clearTimeout(timeout);
            window.removeEventListener("resize", handleResize);
            document.querySelector("footer").style.display = null;
        }
    }, [sAssets]);
    return (
        <div className="view timeline fullscreen align-center">
            <Link to={"../portfolio"}><button className="reveal reveal-area action top left round align-center"><img draggable="false" alt="" width="35" height="35" src="https://saison.one/assetsCommon/navigation_arrow.svg"/></button></Link>
            <h2 className="view-title"><FormattedMessage id="timeline"/></h2>
            <div className="timeline-container" onClick={() => split.length && setSplit([])}>
                {
                    sAssets.length > 0 && groupedAssets.map((current, index) =>
                        <div key={index} className="timeline-item align-center" style={{animationDelay: index / (1.8 * groupedAssets.length) + "s"}}>
                            {
                                current.length > 1 ?
                                <>
                                <div className={`align-center timeline-many ${split === current ? "splitted" : ""}`} style={{height: 40 + current.length * 2 + "vmin", transform: split !== current ? `scale(${Math.max(1 - (current.length * 0.12), minScale)})` : ''}} onClick={() => setSplit(current)}>
                                    {
                                        current.map((current, index) =>
                                            <img draggable="false" key={index} style={getManyStyle(current, index)} height="180" alt="" src={ current[1].thumbnail }/>
                                        )
                                    }
                                </div>
                                {
                                    split === current &&
                                    <div className="split-container reveal-area" style={{minHeight: 40 + current.length * 2 + "vmin"}}>
                                        {split.map((value, index) => <Link key={ index } to={ `../gallery/view?id=${value[0]}&origin=timeline` }><button className="invisible reveal" style={{ animationDelay: index / (1.8 * split.length) + "s", backgroundImage: `url(${ value[1].thumbnail })`, backgroundSize: value[1].tile || "cover", backgroundColor: value[1].colorTheme ? value[1].colorTheme : "" }}/></Link>)}
                                    </div>
                                }
                                </>
                                :
                                <Link key={ index } to={ `../gallery/view?id=${current[0][0]}&origin=timeline` }><img draggable="false" alt="" src={ current[0][1].thumbnail }/></Link>
                            }
                            <span style={{animationDelay: index / 10 + 0.5 + "s"}}>{getFormattedDate(months, current[0])}</span>
                        </div>
                    )
                }
            </div>
            <Link to={"../gallery"}><button className="reveal reveal-area action bottom left round align-center"><img draggable="false" alt="" width="35" height="35" src={ gallery }/></button></Link>
        </div>
    );
}